import { VERIFY_OTP, VERIFY_OTP_FAILURE, VERIFY_OTP_SUCCESS } from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const verifyOtpReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_OTP:
      return { ...state, loading: true };
    case VERIFY_OTP_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case VERIFY_OTP_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default verifyOtpReducer;
